import Vue from 'vue'
import Router from 'vue-router'
import AppHeader from './layout/AppHeader'
import AppFooter from './layout/AppFooter'

import Documentation from './views/Documentation.vue'
import Landing from './views/Landing.vue'
import Wordclouds from './views/Wordclouds.vue'
import Locations from './views/Locations.vue'
import Repositories from './views/Repositories.vue'
import Influencers from './views/Influencers.vue'
import TopPosts from './views/TopPosts.vue'
import TopUrls from './views/TopUrls.vue'
import TopicModeling from './views/TopicModeling.vue'
import TextClassification from './views/TextClassification'
import PlasticTwistChallenge from './views/events/PlasticTwistChallenge'
import PlasticTwistAthens from './views/events/PlasticTwistAthens'
import SwissPilotIdeas from './views/ideas/SwissPilotIdeas'
import GreekPilotIdeas from './views/ideas/GreekPilotIdeas'
import About from './views/About'
import RSS from './views/RSS'

import NotFound from './views/NotFound'
import DutchPilotIdeas from './views/ideas/DutchPilotIdeas'
import PlasticTwistThessaloniki from './views/events/PlasticTwistThessaloniki'
import PlasticTwistIstanbul from './views/events/PlasticTwistIstanbul'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '*',
      components: {
        header: AppHeader,
        default: NotFound,
        footer: AppFooter
      }
    },
    {
      path: '/documentation',
      name: 'documentation',
      components: {
        header: AppHeader,
        default: Documentation,
        footer: AppFooter
      }
    },
    {
      path: '/',
      name: 'landing',
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: '/visualizations/locations',
      name: 'locations',
      components: {
        header: AppHeader,
        default: Locations,
        footer: AppFooter
      }
    },
    {
      path: '/visualizations/wordclouds',
      name: 'wordclouds',
      components: {
        header: AppHeader,
        default: Wordclouds,
        footer: AppFooter
      }
    },
    {
      path: '/repositories',
      name: 'repositories',
      components: {
        header: AppHeader,
        default: Repositories,
        footer: AppFooter
      }
    },
    {
      path: '/prevalent-data/top-posts',
      name: 'top-posts',
      components: {
        header: AppHeader,
        default: TopPosts,
        footer: AppFooter
      }
    },
    {
      path: '/prevalent-data/top-urls',
      name: 'top-urls',
      components: {
        header: AppHeader,
        default: TopUrls,
        footer: AppFooter
      }
    },
    {
      path: '/prevalent-data/influencers',
      name: 'influencers',
      components: {
        header: AppHeader,
        default: Influencers,
        footer: AppFooter
      }
    },
    {
      path: '/tools/text-classification',
      name: 'text-classification',
      components: {
        header: AppHeader,
        default: TextClassification,
        footer: AppFooter
      }
    },
    {
      path: '/visualizations/topic-modeling',
      name: 'topic-modeling',
      components: {
        header: AppHeader,
        default: TopicModeling,
        footer: AppFooter
      }
    },
    // // TODO: DELETE LATER
    // {
    //   path: '/visualizations/topic-modeling-new',
    //   name: 'topic-modeling',
    //   components: {
    //     header: AppHeader,
    //     default: TopicModeling,
    //     footer: AppFooter
    //   }
    // },
    {
      path: '/events/plastictwist-challenge',
      name: 'plastictwist-challenge',
      components: {
        header: AppHeader,
        default: PlasticTwistChallenge,
        footer: AppFooter
      }
    },
    {
      path: '/events/plastictwist-athens',
      name: 'plastictwist-athens',
      components: {
        header: AppHeader,
        default: PlasticTwistAthens,
        footer: AppFooter
      }
    },
    {
      path: '/events/plastictwist-thessaloniki',
      components: {
        header: AppHeader,
        default: PlasticTwistThessaloniki,
        footer: AppFooter
      }
    },
    {
      path: '/events/plastictwist-istanbul',
      components: {
        header: AppHeader,
        default: PlasticTwistIstanbul,
        footer: AppFooter
      }
    },
    {
      path: '/ideas/greek-pilot',
      components: {
        header: AppHeader,
        default: GreekPilotIdeas,
        footer: AppFooter
      }
    },
    {
      path: '/ideas/dutch-pilot',
      components: {
        header: AppHeader,
        default: DutchPilotIdeas,
        footer: AppFooter
      }
    },
    {
      path: '/ideas/swiss-pilot',
      components: {
        header: AppHeader,
        default: SwissPilotIdeas,
        footer: AppFooter
      }
    },
    {
      path: '/about',
      name: 'plastictwist-athens',
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      }
    },
    {
      path: '/rss',
      name: 'rss',
      components: {
        header: AppHeader,
        default: RSS,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
export default router
